<template>
    <div>
      <b-form-input type="date" v-model="modelValue" />
      <small class="text-danger">{{ errors[0] }}</small>
    </div>
  </template>
  
  <script>
  import {
    BFormInput,
  } from "bootstrap-vue";
  export default {
    components: {
      BFormInput,
    },
    props: {
      value: {
        type: "",
      },
      errors: {
        type: "",
      },
    },
    computed: {
      modelValue: {
        get: function () {
          return this.value;
        },
        set: function (data) {
          this.$emit("value", data);
        },
      },
    },
  };
  </script>
  